import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
export var initializeApplicationInsights = function (history) {
    var _a;
    if (!window.AI_INSTRUMENTATION_KEY_FRONTEND) {
        return;
    }
    var reactPlugin = new ReactPlugin();
    var appInsights = new ApplicationInsights({ config: {
            instrumentationKey: window.AI_INSTRUMENTATION_KEY_FRONTEND,
            disableFetchTracking: false,
            enableAjaxErrorStatusText: true,
            enableAjaxPerfTracking: true,
            enableUnhandledPromiseRejectionTracking: true,
            extensions: [reactPlugin],
            extensionConfig: (_a = {},
                _a[reactPlugin.identifier] = { history: history },
                _a)
        } });
    appInsights.loadAppInsights();
    appInsights.trackPageView();
};
export default initializeApplicationInsights;
